import SideBarTool from "@/commons/components/side-bar-tool";
import { Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PSection } from "@/commons/interface/speccommon/section";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { MAJOR } from "@/commons/constants/major";
import { getSectionsByprojectUuid } from "@/api/spec-common/section";
import { getMaterialsByprojectUuid } from "@/api/spec-common/material";
import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import genUUID from "@/commons/utils/gen-uuid";
import { Layer } from "@/commons/interface/geometry/layer";
import { LineType, Polygon } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { STRUCTURE_SIGNAL } from "@/passets/structure-engine/enums/structure-signal";
import { getSectionTypeForPolygon } from "@/commons/enums/speccommon/section";
import { STRUCTURE_SUB_CONTROL } from "@/passets/structure-engine/enums/structure-sub-control";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import TnMessage from "@/commons/widget/message";
import { STRUCTURE_CTRL_TYPE } from "@/passets/structure-engine/enums/structure-control-type";
import { LayerType } from "@/commons/enums/layer-type";

/**
 * 结构支撑
 */
export default function SBracePanel() {
    const { projectUuid, modelUuid } = useParams();
    const [sections, setSections] = useState<PSection[]>([]); // 截面列表
    const [materials, setMaterials] = useState<PMaterial[]>([]); // 材料列表
    const [selSection, setSelSection] = useState<PSection>(null);
    const [selMaterial, setSelMaterial] = useState<PMaterial>(null);
    const [alignmentY, setAlignmentY] = useState<string>('middle'); // Y轴对正
    const [alignmentZ, setAlignmentZ] = useState<string>('middle'); // Z轴对正
    const [angle, setAngle] = useState<number>(0); // 轴转角(度)
    const [iBiasLength, setIBiasLength] = useState<string>('0'); // i节点退让
    const [jBiasLength, setJBiasLength] = useState<string>('0'); // j节点退让

    useEffect(() => {
        if (!projectUuid) return;
        // // 获得支撑列表
        getSectionsByprojectUuid(projectUuid, MAJOR.STRUCTURE).then(res => {
            if (res.status == 200) {
                let sections = res.data || [];
                setSections(sections);
            }
        }).catch(() => {
            message.error("获得截面列表失败")
        })
        getMaterialsByprojectUuid(projectUuid, MAJOR.STRUCTURE).then(res => {
            if (res.status == 200) {
                let materials = res.data || [];
                setMaterials(materials);
            }
        }).catch(() => {
            message.error("获得材料列表失败")
        })
    }, [projectUuid])

    const onSectionChange = (uuid: string) => {
        let section = sections.find(item => item.uuid == uuid);
        setSelSection(section);
    }

    const onMaterialChange = (uuid: string) => {
        let material = materials.find(item => item.uuid == uuid);
        setSelMaterial(material);
    }

    // 点击了布置按钮
    const assemble = () => {
        if (selSection == null || selMaterial == null) {
            TnMessage.error("请选择截面和材料");
            return;
        }
        findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
            let layers: Layer[] = res.data || [];
            let componentLayer = layers?.find(item => item?.type === LayerType.SBRACE);
            if (!!componentLayer) {
                // 存在一个图层为构件图层，绘制的图元都在该图层中
                handleAssemble(componentLayer.uuid);
            } else {
                // 不存在一个图层为构件图层，新建一个图层作为构件图层，绘制的图元都在该图层中
                let uuid = genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: "支撑",
                    color: "#000000",
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    projectUuid: projectUuid,
                    originLayer: false,
                    type: LayerType.SBRACE,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(res => {
                    if (res.status === 200) {
                        graphicStore.context.layerContext.addLayer(newLayer);
                        handleAssemble(newLayer.uuid);
                    }
                }).catch(err => {
                    message.error("无法置为构件图层");
                    console.log(err);
                })
            }
        })
    }

    // 计算偏移
    const getExEy = (polygon: Polygon) => {
        const points = polygon.getPoints();
        let minx = Number.MAX_VALUE;
        let maxx = Number.MIN_VALUE;
        let miny = Number.MAX_VALUE;
        let maxy = Number.MIN_VALUE;
        points.forEach(point => {
            if (point.x < minx) {
                minx = point.x;
            }
            if (point.x > maxx) {
                maxx = point.x;
            }
            if (point.y < miny) {
                miny = point.y;
            }
            if (point.y > maxy) {
                maxy = point.y;
            }
        })
        // const lenx = Math.abs(maxx - minx);
        // const leny = Math.abs(maxy - miny);
        // let ex = lenx / 2;
        // let ey = leny / 2;
        // if (alignmentY === "left") {
        //     ex = ex;
        // } else if (alignmentY === "right") {
        //     ex = -ex;
        // } else {
        //     ex = 0;
        // }
        // if (alignmentZ === "top") {
        //     ey = ey;
        // } else if (alignmentZ === "bottom") {
        //     ey = -ey;
        // } else {
        //     ey = 0;
        // }
        let ex = 0;
        let ey = 0;
        if (alignmentY === "left") {
            ex = Math.abs(minx);
        } else if (alignmentY === "right") {
            ex = -Math.abs(maxx);
        } else {
            ex = 0;
        }
        if (alignmentZ === "top") {
            ey = Math.abs(maxy);
        } else if (alignmentZ === "bottom") {
            ey = -Math.abs(miny);
        } else {
            ey = 0;
        }

        return { ex: ex, ey: ey };
    }

    const handleAssemble = (layerUuid: string) => {
        const polygonType = getSectionTypeForPolygon(selSection.type);
        selSection.polygonType = polygonType;
        const polygons: Polygon[] = graphicStore.extraContext.ToolContext.getPolygonBySection(selSection);
        let bottomFace = polygons[0];
        const exeyData = getExEy(bottomFace);
        const data = {
            sectionUuid: selSection.uuid,
            materialUuid: selMaterial.uuid,
            bottomFace: bottomFace,
            ex: exeyData.ex,
            ey: exeyData.ey,
            angle: angle,
            layerUuid: layerUuid,
            iBiasLength: +iBiasLength,
            jBiasLength: +jBiasLength,
        }
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl
            || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== STRUCTURE_CTRL_TYPE.ADD_SBRACE) {
            // 激活布置构件的二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl(STRUCTURE_SUB_CONTROL.ADDSBRACECONTROL.name);

        }
        graphicStore.extraContext.listeners.getSignal(STRUCTURE_SIGNAL.initSBraceControl).dispatch(data);
    }

    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    支撑
                </div>
                <div className="detail structure-beam-panel">
                    <div className="row compact">
                        <div className="label">截面:</div>
                        <Select
                            size='small'
                            className="select-box"
                            placeholder='截面'
                            onChange={onSectionChange}
                        >
                            {sections.map((item, index) => (
                                <Select.Option key={index} label={item?.name} value={item?.uuid}>
                                    {item?.name || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">材料:</div>
                        <Select
                            size='small'
                            className="select-box"
                            placeholder='材料'
                            onChange={onMaterialChange}
                        >
                            {materials.map((item, index) => (
                                <Select.Option key={index} label={item?.name} value={item?.uuid}>
                                    {item?.name || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">Y轴对正:</div>
                        <Select
                            size='small'
                            className="select-box"
                            value={alignmentY}
                            onChange={(value) => setAlignmentY(value)}
                        >
                            <Select.Option value="left">左</Select.Option>
                            <Select.Option value="middle">中间</Select.Option>
                            <Select.Option value="right">右</Select.Option>
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">Z轴对正:</div>
                        <Select
                            size='small'
                            className="select-box"
                            value={alignmentZ}
                            onChange={(value) => setAlignmentZ(value)}
                        >
                            <Select.Option value="top">顶</Select.Option>
                            <Select.Option value="middle">中间</Select.Option>
                            <Select.Option value="bottom">底</Select.Option>
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">轴转角(度):</div>
                        <Input className="input-box" value={angle} onChange={(e) => {
                            let value = e.target.value;
                            const reg = /^-?\d*(\.\d*)?$/;
                            if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                let angle: number = +value;
                                while (angle < 0) {
                                    angle += 360;
                                }
                                while (angle > 360) {
                                    angle -= 360;
                                }
                                setAngle(angle);
                            }
                        }} />
                    </div>
                    <div className="row compact">
                        <div className="label">起点退让:</div>
                        <Input className="input-box" value={iBiasLength} onChange={(e) => {
                            let value = e.target.value;
                            const reg = /^-?\d*(\.\d*)?$/;
                            if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                setIBiasLength(value);
                            }
                        }} />
                    </div>
                    <div className="row compact">
                        <div className="label">终点退让:</div>
                        <Input className="input-box" value={jBiasLength} onChange={(e) => {
                            let value = e.target.value;
                            const reg = /^-?\d*(\.\d*)?$/;
                            if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                                setJBiasLength(value);
                            }
                        }} />
                    </div>
                    <div className='bottom-footer'>
                        <div className="ope-btn">
                            <div className="insert-button" onClick={assemble}>
                                <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                                <div className="text">布置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}